module.exports = __webpack_public_path__ + "media/wo_chi_fan_song_level2.e8650c91.mp3";